import $ from 'jquery';

function restrictPhoneNumberInput(inputContainer) {
    var input = inputContainer.find('input');
    input.on('input', function() {
        var cleanedValue = input.val().replace(/\D/g, '');


        if (cleanedValue.length > 10) {
            cleanedValue = cleanedValue.slice(0, 10);
        }

        input.val(cleanedValue);
    });

    input.on('keypress', function(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if ((charCode >= 48 && charCode <= 57) || charCode === 8 || charCode === 46) {
            return true;
        }

        evt.preventDefault();
        return false;
    });
}

function restrictNameInput(inputContainer) {
    var input = inputContainer.find('input');
    input.on('input', function() {
        var cleanedValue = input.val().replace(/\d/g, '');

        input.val(cleanedValue);
    });

    input.on('keypress', function(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if ((charCode >= 48 && charCode <= 57) || charCode === 8 || charCode === 46) {
            evt.preventDefault();
            return false;
        }

        return true;
    });
}

// Apply to all phone number fields
$('.app-phone-number-validation').each(function() {
    restrictPhoneNumberInput($(this));
});


$('.app-name-validation').each(function() {
    restrictNameInput($(this));
});